import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {FirebaseService} from '../../../service/firebase/firebase.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DatastoreService} from '../../../service/datastore/datastore.service';
import {BundeslandFilterService} from '../../../service/bundeslandFilter/bundesland-filter.service';
import {filter, map, take} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-vorhersage',
  templateUrl: './vorhersage.component.html',
  styleUrls: ['./vorhersage.component.css']
})
export class VorhersageComponent implements OnInit {

  isLoading = true;
  firstInit = true;
  subscriptionUebersicht$: Subscription;
  bundesLaender = this.bundeslandService.getSelectedBundesLaenderNamen();


  /**
   * TODO: ES MUSS EIN BESSERES DATENKEEPING HER!
   */
  constructor(private bundeslandService: BundeslandFilterService,
              private datastoreService: DatastoreService,
              private firebaseService: FirebaseService,
              private snackBar: MatSnackBar,
              public router: Router) {
    this.bundeslandService.onFilterUpdated.subscribe(laender => {
      this.bundesLaender.length = 0;
      laender.forEach(land => this.bundesLaender.push(land.name));
      this.getVorhersagenUebersicht();
    }, error => {
      this.openSnackBarWithRetryOption(error);
    });


  }

  ngOnInit() {
    this.getVorhersagenUebersicht();
    this.datastoreService.onRefreshVorhersagen.subscribe((refresh) => {
      if (refresh) {
        this.getVorhersagenUebersicht();
      }
    });
  }

  ngOnDestroy() {
    if (this.subscriptionUebersicht$ !== undefined) {
      this.subscriptionUebersicht$.unsubscribe();
    }
  }


  private getVorhersagenUebersicht() {
    this.isLoading = true;
    this.subscriptionUebersicht$ = this.firebaseService.getVorhersagenDeutschlandHeute24h(this.bundesLaender)
      .pipe(take(1), map(data => this.datastoreService.mapDataTo24hHeuteVorhersagen(data)))
      .subscribe((data) => {
        //Navigiere nur bei der ersten Initialisierung, damit bei jeder Filteränderung das Routing erhalten bleibt
        if (this.firstInit) {
          this.router.navigate(['vorhersagen/computer-mos/uebersicht']);
          this.firstInit = false;
        }
        this.isLoading = false;
      }, error => {
        this.openSnackBarWithRetryOption(error);
        this.isLoading = false;
      });
  }

  private openSnackBarWithRetryOption(error) {
    const snackRef = this.snackBar.open(`Ladefehler ${error}`, 'Erneut laden');
    snackRef.onAction().subscribe(() => {
      console.log('Action done!');
    });
  }

}
